var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBestseller(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 17,
    viewBox: "0 0 85 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 76.287205,8.5643102 8.693152,9.0165108 c -7.856873,-0.03332 -77.2474753,0.05871 -85.00289394,0.0094 l 0.0019704,-18.0079972 85.0126435,-0.003007 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBestseller);
export default __webpack_public_path__ + "static/media/bestseller.1012c9b94418585ff3e925b1cde0ee6b.svg";
export { ForwardRef as ReactComponent };